// src/components/TopBar.jsx
import React from "react";

function TopBar({ centerContent, rightContent }) {
  return (
    <header className="bond-topbar">
      <div className="bond-topbar-left">
        <span className="bond-logo-text">BOND</span>
      </div>

      <div className="bond-topbar-center">
        {centerContent}
      </div>

      <div className="bond-topbar-right">
        {rightContent}
      </div>
    </header>
  );
}

export default TopBar;
